import React, { useCallback } from 'react';
import classNames from 'classnames';

import { ButtonGroup, Tooltip } from '@primer/react';

import Button from '../Button/Button';

const ButtonTab = ({
  option,
  onClick,
  selectedOption,
  tooltipText = null,
  disabled = false,
  id,
}) => {
  const buttonProps = selectedOption === option ? {
    backgroundColor: '#D5D5D5',
  } : {};

  const onButtonClick = useCallback(() => onClick(option), [onClick, option])

  if (tooltipText) {
    return (
      <Button
        sx={buttonProps}
        className={classNames({ 'bg-brand': selectedOption === option })}
        onClick={onButtonClick}
        disabled={disabled}
        id={id}
      >
        {option}
        <Tooltip aria-label={tooltipText}>
          <div className="z-16 absolute w-20 h-8 -left-16 -top-2" />
        </Tooltip>
      </Button>
    )
  }
  return (
    <Button
      sx={buttonProps}
      className={classNames({ 'bg-brand': selectedOption === option })}
      onClick={onButtonClick}
      disabled={disabled}
      id={id}
    >
      {option}
    </Button>
  )
}

export const ButtonTabGroup = ({
  className,
  selectedOption,
  options = [],
  onItemSelected,
}) => (
  <ButtonGroup className={classNames('flex', className)}>
    {
      options.map(option => (
        <ButtonTab
          key={option.value}
          option={option.value}
          selectedOption={selectedOption}
          onClick={onItemSelected}
          tooltipText={option.tooltipText}
          disabled={option.disabled}
          id={option.id}
        />
      ))
    }
  </ButtonGroup>
)

export default ButtonTabGroup;
